"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Stamp_1 = require("./Stamp");
var CreateStamp_1 = require("./CreateStamp");
var AcStampButton_1 = require("./AcStampButton");
exports.AcSetPhraseStampButton = function (_a) {
    var _b = _a.text, text = _b === void 0 ? '' : _b, dropdownProps = _a.dropdownProps, dropdownData = _a.dropdownData;
    var setPhraseTextbox = CreateStamp_1.createSetPhraseForButton(text);
    var getStamp = function () {
        var _stamp = Stamp_1.Stamp.setPhraseStamp(text, dropdownData);
        return _stamp;
    };
    return (react_1.default.createElement(AcStampButton_1.AcStampButton, { stamp: getStamp(), width: 250, height: setPhraseTextbox.height, size: "stamp_lg", dropdownProps: dropdownProps, dropdownData: dropdownData }));
};
exports.AcSetPhraseStampButton.displayName = 'AcSetPhraseStampButton';
//# sourceMappingURL=AcSetPhraseStampButton.js.map